// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.memberbannertext {
  position: absolute;
  left: 3%;
  top: 35%;
}

.memberbar {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  top: 0px;
  width: 100%;
}

.membersq {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 300px;
  color: white;
  font-size: 5rem;
  text-align: center;
  justify-content: center;
}

.titleleft {
  text-align: left;
}

@media (max-width: 1200px) {
  .memberbar {
    flex-wrap: wrap;
  }
  .membersq {
    margin-bottom: 2rem;
  }
}
.contract-terms {
  max-width: 100%;
  margin: 0 auto;
  padding: 32px 36px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  color: #333333;
  font-size: 16px;
  line-height: 1.9;
  letter-spacing: 0.02em;
}
.contract-terms > h4 {
  margin-bottom: 24px !important;
  padding-bottom: 18px;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
  color: #224040;
  border-bottom: 2px solid #224040;
}
.contract-terms > h5 {
  position: relative;
  margin-top: 42px !important;
  margin-bottom: 18px;
  padding: 12px 16px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
  color: #224040;
  background: #f3f7f6;
  border-left: 5px solid #224040;
  border-radius: 4px;
}
.contract-terms h6 {
  margin-top: 26px !important;
  margin-bottom: 12px;
  font-size: 17px;
  font-weight: 700;
  color: #2f5d50;
}
.contract-terms p {
  margin-bottom: 14px;
  line-height: 1.9;
}
.contract-terms ul,
.contract-terms ol {
  margin-top: 10px;
  margin-bottom: 20px;
  padding-left: 28px;
}
.contract-terms li {
  margin-bottom: 8px;
  padding-left: 4px;
  line-height: 1.8;
}
.contract-terms ul li::marker {
  color: #224040;
}
.contract-terms ol li::marker {
  color: #224040;
  font-weight: 700;
}
.contract-terms hr {
  margin: 36px 0;
  border: 0;
  border-top: 1px solid #e5e7eb;
  opacity: 1;
}
.contract-terms a {
  color: #1f6655;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.contract-terms a:hover {
  color: #153f36;
}
.contract-terms p {
  overflow-wrap: anywhere;
  word-break: normal;
}`, "",{"version":3,"sources":["webpack://./src/pages/member/styles/member.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,QAAA;EACA,QAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,QAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI;IACI,eAAA;EACN;EACE;IACI,mBAAA;EACN;AACF;AAGA;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,mBAAA;EAEA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAHJ;AAMI;EACI,8BAAA;EACA,oBAAA;EAEA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,cAAA;EACA,gCAAA;AANR;AAUI;EACI,kBAAA;EAEA,2BAAA;EACA,mBAAA;EACA,kBAAA;EAEA,eAAA;EACA,gBAAA;EACA,gBAAA;EAEA,cAAA;EACA,mBAAA;EAEA,8BAAA;EACA,kBAAA;AAZR;AAgBI;EACI,2BAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,cAAA;AAhBR;AAmBI;EACI,mBAAA;EACA,gBAAA;AAjBR;AAoBI;;EAEI,gBAAA;EACA,mBAAA;EACA,kBAAA;AAlBR;AAqBI;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AAnBR;AAsBI;EACI,cAAA;AApBR;AAuBI;EACI,cAAA;EACA,gBAAA;AArBR;AAyBI;EACI,cAAA;EACA,SAAA;EACA,6BAAA;EACA,UAAA;AAvBR;AA2BI;EACI,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;AAzBR;AA2BQ;EACI,cAAA;AAzBZ;AA8BI;EACI,uBAAA;EACA,kBAAA;AA5BR","sourcesContent":[".memberbannertext {\n    position: absolute;\n    left: 3%;\n    top: 35%;\n}\n\n.memberbar{\n    position: relative;\n    display: flex;\n    justify-content: space-evenly;\n    top: 0px;\n    width: 100%;\n}\n\n.membersq{\n    display: flex;\n    flex-direction: column;\n    width: 300px;\n    height: 300px;\n    color: #ffff;\n    font-size: 5rem;\n    text-align: center;\n    justify-content: center;\n}\n\n.titleleft {\n    text-align: left ;\n}\n\n@media (max-width:1200px) {\n    .memberbar {\n        flex-wrap: wrap;\n    }\n    .membersq {\n        margin-bottom: 2rem;\n\n    }\n}\n\n.contract-terms {\n    max-width: 100%;\n    margin: 0 auto;\n    padding: 32px 36px;\n\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n\n    color: #333333;\n    font-size: 16px;\n    line-height: 1.9;\n    letter-spacing: 0.02em;\n\n    // 主標題\n    > h4 {\n        margin-bottom: 24px !important;\n        padding-bottom: 18px;\n\n        font-size: 26px;\n        font-weight: 700;\n        line-height: 1.5;\n        text-align: center;\n\n        color: #224040;\n        border-bottom: 2px solid #224040;\n    }\n\n    // 每一大項標題\n    > h5 {\n        position: relative;\n\n        margin-top: 42px !important;\n        margin-bottom: 18px;\n        padding: 12px 16px;\n\n        font-size: 20px;\n        font-weight: 700;\n        line-height: 1.5;\n\n        color: #224040;\n        background: #f3f7f6;\n\n        border-left: 5px solid #224040;\n        border-radius: 4px;\n    }\n\n    // CPA、CMA、EA、小節標題\n    h6 {\n        margin-top: 26px !important;\n        margin-bottom: 12px;\n\n        font-size: 17px;\n        font-weight: 700;\n\n        color: #2f5d50;\n    }\n\n    p {\n        margin-bottom: 14px;\n        line-height: 1.9;\n    }\n\n    ul,\n    ol {\n        margin-top: 10px;\n        margin-bottom: 20px;\n        padding-left: 28px;\n    }\n\n    li {\n        margin-bottom: 8px;\n        padding-left: 4px;\n        line-height: 1.8;\n    }\n\n    ul li::marker {\n        color: #224040;\n    }\n\n    ol li::marker {\n        color: #224040;\n        font-weight: 700;\n    }\n\n    // 分隔線\n    hr {\n        margin: 36px 0;\n        border: 0;\n        border-top: 1px solid #e5e7eb;\n        opacity: 1;\n    }\n\n    // 連結\n    a {\n        color: #1f6655;\n        font-weight: 500;\n        text-decoration: underline;\n        text-underline-offset: 3px;\n\n        &:hover {\n            color: #153f36;\n        }\n    }\n\n    // 英文付款資訊比較容易很長\n    p {\n        overflow-wrap: anywhere;\n        word-break: normal;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
